export default "__VITE_ASSET__5f41aa26__"